import CompaniesPage from '../companies/companies_page';

const SuperAdminPage = () => {
    return <CompaniesPage data-testid="super-admin-companies-page" />;
};

export default SuperAdminPage;
